import { BaseService } from "./BaseService";

export interface LeadData {
  name: string;
  email: string;
  phone: string;
  message: string;
  propertyCode?: string;
}

export interface LeadResponse {
  id: string;
  name: string;
  email: string;
  phone: string;
  message: string;
  propertyCode: string | null;
  createdAt: string;
}

export class ContactService extends BaseService {
  constructor() {
    super("leads");
  }

  async sendLead(data: LeadData): Promise<LeadResponse> {
    return this.post<LeadResponse>("", { body: data });
  }
}
